// this function takes functions as arguments and calls them with the arguments

export const callAll =
  (...fns) =>
  (...args) =>
    fns.forEach((fn) => fn && fn(...args));
